import { CollapsibleSection } from "components/collapsibleSection";
import { FieldObjectType, IPickupAttractionParticipantDetail } from "interfaces";
import { get } from "lodash";
import React from "react";
import { getInputFieldValue } from "utills/helpers";

export const RegistrationInformationSection = ({participantDetailData} : {participantDetailData: IPickupAttractionParticipantDetail | null}) => {
  return (
    <CollapsibleSection 
      label="Registration Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        {Object.keys(participantDetailData?.attendant_template ?? {}).map(key => (
          <React.Fragment key={key}>
            <div className="col-span-full">
              <p className="text-lg font-medium">
                {participantDetailData?.attendant_template[key].label_en}
              </p>
            </div>
            {(participantDetailData?.attendant_template[key].fields ?? []).map(field => (
              <div className="sm:col-span-6 grid gap-x-4 grid-cols-12 gap-y-2 col-span-full" key={field.key}>
                <div className="col-span-full">
                  <p className="font-medium">
                    {field.label_en}
                  </p>
                </div>
                <div className="col-span-full">
                  {field.key.indexOf('phone') !== -1 ? (
                    <p>
                      {get(participantDetailData?.participant, `${field.key}_area_code`, "") 
                        ? `(+${get(participantDetailData?.participant, `${field.key}_area_code`, "")})` 
                        : ""} {get(participantDetailData?.participant , field.key, "")}
                    </p>
                  ) : field.object === FieldObjectType.CLUBS ? (
                    <p>
                      {get(participantDetailData?.participant , "club_name", "") || get(participantDetailData?.participant , "club", "")}
                    </p>
                  ) : (
                    <p className={String(get(participantDetailData?.participant , field.key, "")) ? "" : "text-gray-400"}>
                      {getInputFieldValue(field, get(participantDetailData?.participant , field.key, ""))}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </React.Fragment>
        ))}
      </div>
    </CollapsibleSection>
    
  )
}